<ion-header>
  <ion-toolbar color="secondary">
    <ion-title>{{datos.proyecto|uppercase}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="primary">
    <ion-title>{{subtitulo|uppercase}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <swiper-container pagination="true" class="swiperProg">
    @for (dia of datos.datosSemana; track dia.fecha) {
      <swiper-slide>
        <div class="main">
          <div class="item-divider">
            <p>{{dia.fecha|date:"fullDate"|uppercase}} </p>
          </div>
          <div class="item-titulo">
            <h2>{{dia.titulo || 'Sin título'}}</h2>
          </div>
          @if (dia.titulo !== 'Festivo' && dia.titulo !== 'Vacaciones') {
            <div class="item-divider">
              <p>OBJETIVOS</p>
            </div>
            <div class="item-text-wrap ion-padding">
              <quill-view [content]="dia.obj"></quill-view>
            </div>
            <div class="item-divider">
              <p>DESCRIPCIÓN</p>
            </div>
            <div class="item-text-wrap ion-padding">
              <quill-view [content]="dia.desc"></quill-view>
            </div>
          }
          @if (dia.titulo === 'Festivo') {
            <div class="imagen ion-padding">
              <img src="assets/img/fireworks.png" alt="festivo">
            </div>
          }
          @if (dia.titulo === 'Vacaciones') {
            <div class="imagen ion-padding">
              <img src="assets/img/sombrilla.png" alt="vacaciones">
            </div>
          }
        </div>
      </swiper-slide>
    }
  </swiper-container>
</ion-content>
